import { Directive, HostListener } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';

@Directive({
    selector: '[appFocusFirstCell]',
    standalone: false
})
export class FocusFirstCellDirective {
  constructor(private readonly host: DxDataGridComponent) {}

  @HostListener('onInitNewRow', ['$event']) onInitNewRow(e) {
    // Fix for default devextreme grid behavior
    setTimeout(() => {
      this.host.instance.focus(this.host.instance.getCellElement(0, 0));
    }, 100);
  }
}
